export const HOLIDAY_EVENT = [
  {
    color: {
      primary: '#f7ed10',
      secondary: '#f7ed10',
    },
    cssClass: 'holiday-event',
  },
];

export const ACCELERATION_EVENT = [
  {
    color: {
      primary: '#c26aa4',
      secondary: '#c26aa4',
    },
    cssClass: 'acceleration-event',
  },
];

export const PUPIL_EVENT = [
  {
    color: {
      primary: '#8cce73',
      secondary: '#8cce73',
    },
    cssClass: 'pupil-event',
  },
];

export const UNASSIGNED_EVENT = [
  {
    color: {
      primary: '#c26aa4',
      secondary: '#c26aa4',
    },
    cssClass: 'unassigned-event',
  },
];
